import { Fragment, useEffect, useRef, useState } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { useAuthDispatch } from '../../contexts/auth';

const initialFormData = Object.freeze({
	company: 'internal',
	username: '',
	password: '',
	clientId: '',
});

export const Login = ({ open, setOpen }) => {
	const [loginForm, setLoginForm] = useState(initialFormData);
	const [hostName, setHostName] = useState('');
	const cancelButtonRef = useRef(null);

	const auth = useAuthDispatch();

	useEffect(() => {
		setHostName(window.location.host);
	}, []);

	const handleChange = e => {
		setLoginForm({
			...loginForm,

			// Trimming any whitespace
			[e.target.name]: e.target.value.trim(),
		});
	};

	const onLogin = () => {
		return auth
			.login(loginForm)
			.then(() => {
				setOpen(false);
			})
			.catch(e => {
				// setMessages({
				// 	type: 'error',
				// 	message:
				// 		getLoginError(e) === 'Bad credentials'
				// 			? "Sorry, that password didn't work--try again"
				// 			: getLoginError(e),
				//setIsLoggingIn(false);
				console.log(e);
				return e;
			});
	};

	return (
		<Transition.Root show={open} as={Fragment}>
			<Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={() => null}>
				<Transition.Child
					as={Fragment}
					enter="ease-out duration-300"
					enterFrom="opacity-0"
					enterTo="opacity-100"
					leave="ease-in duration-200"
					leaveFrom="opacity-100"
					leaveTo="opacity-0">
					<div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
				</Transition.Child>

				<div className="fixed inset-0 z-10 overflow-y-auto">
					<div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
						<Transition.Child
							as={Fragment}
							enter="ease-out duration-300"
							enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
							enterTo="opacity-100 translate-y-0 sm:scale-100"
							leave="ease-in duration-200"
							leaveFrom="opacity-100 translate-y-0 sm:scale-100"
							leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
							<Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
								<div>
									<div className="mt-3 text-center sm:mt-5">
										<Dialog.Title
											as="h3"
											className="text-lg font-medium leading-6 text-gray-900"></Dialog.Title>
										<div className="mt-2">
											<p className="text-lg">Admin Console</p>
										</div>
									</div>
									<div>
										<div className="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-1">
											{hostName.startsWith('admin.') && (
												<div className="sm:col-span-1">
													<label
														htmlFor="input_company"
														className="block text-sm font-medium text-gray-700">
														Company
													</label>
													<input
														required
														name="company"
														type="text"
														className="block w-full min-w-0 flex-1 rounded-none rounded-l-md rounded-r-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm invalid:border-red-500"
														id="input_company"
														onChange={handleChange}
														tabIndex="1"
													/>
												</div>
											)}
											<div className="sm:col-span-1">
												<label
													htmlFor="input_username"
													className="block text-sm font-medium text-gray-700">
													Username
												</label>
												<input
													required
													name="username"
													type="text"
													className="block w-full min-w-0 flex-1 rounded-none rounded-l-md rounded-r-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm invalid:border-red-500"
													id="input_username"
													onChange={handleChange}
													tabIndex="2"
												/>
											</div>
											<div className="sm:col-span-1">
												<div>
													<label
														htmlFor="input_password"
														className="block text-sm font-medium text-gray-700">
														Password
													</label>
													<input
														className="block w-full min-w-0 flex-1 rounded-none rounded-l-md rounded-r-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm invalid:border-red-500"
														id="input_password"
														type="password"
														name="password"
														onChange={handleChange}
														tabIndex="6"
													/>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
									<div className="sm:col-span-1 py-2">
										<button
											type="button"
											className="inline-flex w-full justify-center rounded-md border border-gray-300 px-4 py-2 text-base font-medium text-gray-500 shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:col-start-2 sm:text-sm"
											onClick={() => setOpen(false)}>
											Cancel
										</button>
									</div>
									<div className="sm:col-span-1 py-2">
										<button
											type="button"
											className="inline-flex w-full justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:col-start-2 sm:text-sm"
											onClick={() => onLogin()}>
											SIGN IN
										</button>
									</div>
								</div>
							</Dialog.Panel>
						</Transition.Child>
					</div>
				</div>
			</Dialog>
		</Transition.Root>
	);
};
